/* Native cart order labels. Prices, permissions and checkout remain Shopify's responsibility. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root?.document || root.customElements.get('saber-property-purchasing')) return;
  const document = root.document;
  const ui = value => root.SaberTranslateUi ? root.SaberTranslateUi(value) : value;
  root.SaberProjectCartLinks = { encodeCart: api.encodeCart, decodeItems: api.decodeItems };
  let state = null, saving = null;
  const widgets = () => [...document.querySelectorAll('saber-property-purchasing')];
  const paint = (message, error = false) => {
    document.querySelectorAll('.cart-dynamic-checkout-buttons').forEach(surface => { surface.inert = Boolean(state?.dirty || saving); surface.setAttribute('aria-disabled',String(Boolean(state?.dirty || saving))); });
    widgets().forEach(widget => {
    if (!state || widget.dataset.scope !== state.scope) return;
    widget.querySelectorAll('[data-purchasing-field]').forEach(field => {
      const value = state.values[field.dataset.purchasingField] || '';
      if (field.value !== value) field.value = value;
    });
    const button = widget.querySelector('[data-purchasing-save]');
    if (button) { button.disabled = Boolean(saving); button.textContent = ui(saving ? 'Saving…' : 'Save order details'); }
    const status = widget.querySelector('[data-purchasing-status]');
    if (status && message) { status.textContent = ui(message); status.setAttribute('role', error ? 'alert' : 'status'); status.classList.toggle('is-error', error); }
    });
  };
  const save = async () => {
    if (saving) { await saving; if (state.dirty) return save(); return; }
    if (!state || !state.dirty) return;
    const targetState = state;
    const requested = {...targetState.values, [api.CONTEXT]: targetState.scope};
    const revision = state.revision;
    const endpoint = new URL('cart/update.js', new URL(state.root, root.location.origin));
    if (endpoint.origin !== root.location.origin) throw new Error('The cart address could not be verified. Refresh and try again.');
    saving = (async () => {
      const controller = new AbortController();
      const timeout = root.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await root.fetch(endpoint.href, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:requested}),signal:controller.signal});
        const cart = await response.json();
        if (!response.ok || !api.matches(cart.attributes, requested)) throw new Error('Your order details were not saved. Please try again before checking out.');
        if (state === targetState && state.revision === revision) state.dirty = false;
        document.dispatchEvent(new CustomEvent('saber:purchasing-saved', {detail:{attributes:requested}}));
      } catch(error) {
        throw new Error(error.name === 'AbortError' ? 'Saving took too long. Please try again before checking out.' : error.message || 'Your order details could not be saved.');
      } finally { root.clearTimeout(timeout); }
    })();
    paint('Saving order details…');
    try { await saving; }
    finally { saving = null; paint(); }
    if (state.dirty) return save();
    paint('Order details saved to your cart.');
  };
  class PurchasingCenter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let initial; try {initial = JSON.parse(this.dataset.initial || '{}');} catch {initial = {};}
      if (!state || state.scope !== this.dataset.scope) state = {scope:this.dataset.scope,root:this.dataset.rootUrl || '/',values:api.values(initial),revision:0,dirty:Boolean(initial[api.CONTEXT] && initial[api.CONTEXT] !== this.dataset.scope)};
      this.addEventListener('input', event => {
        const field = event.target.closest('[data-purchasing-field]'); if (!field) return;
        const key = field.dataset.purchasingField;
        if (!api.FIELDS.includes(key)) return;
        state.values[key] = field.value.slice(0, api.LIMITS[key]);
        state.revision++; state.dirty = true; paint('Unsaved changes. Save these details before ordering.');
      });
      this.querySelector('[data-purchasing-save]')?.addEventListener('click', async () => {
        state.dirty = true;
        try {await save();} catch(error) {paint(error.message,true);}
      });
      const shareButton = this.querySelector('[data-purchasing-share]');
      const shareStatus = this.querySelector('[data-purchasing-share-status]');
      const shareLink = this.querySelector('[data-purchasing-share-link]');
      const shareMessage = (message, error = false) => {
        if (!shareStatus) return;
        shareStatus.textContent = ui(message);
        shareStatus.setAttribute('role', error ? 'alert' : 'status');
      };
      shareButton?.addEventListener('click', async () => {
        if (shareButton.disabled) return;
        shareButton.disabled = true;
        const controller = new AbortController();
        const timeout = root.setTimeout(() => controller.abort(), 15000);
        shareMessage('Checking your current cart…');
        try {
          const endpoint = new URL('cart.js', new URL(this.dataset.rootUrl || '/', root.location.origin));
          if (endpoint.origin !== root.location.origin) throw new Error('The cart address could not be verified.');
          const response = await root.fetch(endpoint.href, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}, signal:controller.signal});
          if (!response.ok) throw new Error('Your cart could not be read. Refresh and try again.');
          shareLink.value = api.encodeCart(await response.json(), this.dataset.shareUrl, root.location.origin);
          this.querySelector('[data-purchasing-share-panel]').hidden = false;
          this.querySelector('[data-purchasing-share-copy-wrap]').hidden = false;
          shareLink.focus(); shareLink.select();
          shareMessage('Your link is ready. The recipient reviews current prices and availability before adding anything.');
        } catch (error) {
          if (shareLink) shareLink.value = '';
          this.querySelector('[data-purchasing-share-panel]').hidden = true;
          this.querySelector('[data-purchasing-share-copy-wrap]').hidden = true;
          shareMessage(error.name === 'AbortError' ? 'Reading your cart took too long. Please try again.' : error.message, true);
        } finally {root.clearTimeout(timeout);shareButton.disabled = false;}
      });
      this.querySelector('[data-purchasing-share-copy]')?.addEventListener('click', async () => {
        if (!shareLink?.value) return;
        shareLink.focus(); shareLink.select();
        try {
          if (!root.navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await root.navigator.clipboard.writeText(shareLink.value);
          shareMessage('Project cart link copied.');
        } catch (_) {shareMessage('Select and copy the highlighted link to share it.');}
      });
      paint(state.dirty ? 'Previous account labels have been cleared. Save to update this cart.' : null);
      const outerForm = this.closest('form');
      if (outerForm) outerForm.dataset.purchasingCart = 'true';
    }
  }
  root.customElements.define('saber-property-purchasing', PurchasingCenter);
  const checkedForms = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof root.HTMLFormElement)) return;
    if (checkedForms.has(form)) {checkedForms.delete(form);return;}
    const submitter = event.submitter;
    const checkout = submitter?.name === 'checkout' || form.matches('[data-purchasing-cart]');
    if (!checkout || !state || !state.dirty) return;
    event.preventDefault();event.stopImmediatePropagation();
    try {
      await save();
      if (!form.isConnected) throw new Error('The cart refreshed. Review your saved details and select checkout again.');
      checkedForms.add(form);
      if (submitter?.isConnected) form.requestSubmit(submitter); else form.requestSubmit();
    } catch(error) {paint(error.message,true); const widget=widgets().find(w=>w.offsetParent!==null);if(widget){widget.querySelector('details').open=true;widget.querySelector('[data-purchasing-status]')?.scrollIntoView({block:'nearest'});}}
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || !state?.dirty) return;
    const url = new URL(link.href,root.location.href);
    if (url.origin !== root.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    try {await save();root.location.assign(url.href);} catch(error) {paint(error.message,true);}
  }, true);
})(typeof window === 'undefined' ? null : window, function () {
  const LIMITS = Object.freeze({'Property name':100,'Building':100,'Apartment / unit':100,'PO reference':100,'Delivery contact':100,'Delivery phone':60,'Receiving hours':160,'Access instructions':500,'Preferred drop-off location':250});
  const FIELDS=Object.freeze(Object.keys(LIMITS));
  const CONTEXT='_Saber purchasing context';
  const values=input=>Object.fromEntries(FIELDS.map(key=>[key,String(input?.[key]||'').slice(0,LIMITS[key])]));
  const matches=(actual,requested)=>[...FIELDS,CONTEXT].every(key=>String(actual?.[key]||'')===String(requested[key]||''));
  const id = value => typeof value === 'string' && /^[1-9]\d{0,19}$/.test(value);
  const handle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9_-]{0,199}$/.test(value);
  const quantity = value => Number.isSafeInteger(value) && value > 0 && value <= 1000000;
  function decodeItems(hash, rootUrl = '/') {
    if (typeof hash !== 'string' || !hash.startsWith('#cart=') || hash.length > 24000) throw new Error('Open a complete project cart link from this store.');
    let data;
    try {
      const encoded = hash.slice(6);
      if (!/^[A-Za-z0-9_-]+$/.test(encoded)) throw new Error('Invalid encoding');
      data = JSON.parse(atob(encoded.replace(/-/g,'+').replace(/_/g,'/')));
    } catch (_) {throw new Error('This project cart link could not be read. Ask the sender to create a new link.');}
    if (!Array.isArray(data) || data.length !== 2 || data[0] !== 1 || !Array.isArray(data[1]) || !data[1].length || data[1].length > 100) throw new Error('This project cart link must contain between 1 and 100 products.');
    if (typeof rootUrl !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(rootUrl)) throw new Error('The store address could not be verified.');
    const seen = new Set();
    return data[1].map(row => {
      if (!Array.isArray(row) || row.length !== 3 || !handle(row[0]) || !id(row[1]) || !quantity(row[2]) || seen.has(row[1])) throw new Error('This project cart contains an invalid or repeated product. Ask the sender to create a new link.');
      seen.add(row[1]);
      return {url:rootUrl+'products/'+row[0],variantId:row[1],quantity:row[2]};
    });
  }
  function encodeCart(cart, destination, origin) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) throw new Error('Add products to your cart before creating a project link.');
    if (cart.items.length > 100) throw new Error('Share up to 100 products at a time.');
    if (!destination) throw new Error('The project cart page could not be found. Refresh and try again.');
    const page = new URL(destination, origin);
    if (page.origin !== origin || page.username || page.password) throw new Error('Use a project cart page from this store.');
    const grouped = new Map();
    cart.items.forEach(item => {
      if (item.selling_plan_allocation || item.selling_plan || item.has_components || item.item_components?.length || Object.values(item.properties || {}).some(value => value !== null && value !== '')) throw new Error('Personalized, bundled or subscription items need their product options. Share those product pages separately.');
      const productUrl = new URL(item.url || '', origin);
      const productHandle = item.handle || productUrl.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
      const variantId = String(item.variant_id || item.id || '');
      if (productUrl.origin !== origin || !handle(productHandle) || !id(variantId) || !quantity(item.quantity)) throw new Error('A cart item cannot be shared safely. Open its product page for ordering options.');
      const prior = grouped.get(variantId);
      const total = item.quantity + (prior?.[2] || 0);
      if (!quantity(total) || (prior && prior[0] !== productHandle)) throw new Error('A product quantity or reference could not be shared.');
      grouped.set(variantId, [productHandle,variantId,total]);
    });
    const encoded = btoa(JSON.stringify([1,[...grouped.values()]])).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    if (encoded.length > 23994) throw new Error('This project link is too long. Share a smaller cart.');
    page.hash = 'cart='+encoded;
    return page.href;
  }
  return Object.freeze({FIELDS,CONTEXT,LIMITS,values,matches,encodeCart,decodeItems});
});
